"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FileSaver = require("file-saver");
var XLSX = require("xlsx");
var ExportExcel = /** @class */ (function (_super) {
    __extends(ExportExcel, _super);
    function ExportExcel(props) {
        var _this = _super.call(this, props) || this;
        _this.exportToCSV = function () {
            if (!_this.props.sheets) {
                return;
            }
            var fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            var bookType = _this.props.bookType || 'xlsx';
            var sheetsDictionary = {};
            _this.props.sheets.forEach(function (sheet) {
                var worksheet = XLSX.utils.json_to_sheet(sheet.data);
                sheetsDictionary[sheet.name] = worksheet;
            });
            var workbook = { Sheets: sheetsDictionary, SheetNames: Object.keys(sheetsDictionary) };
            var excelBuffer = XLSX.write(workbook, { bookType: bookType, type: 'array' });
            var data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "".concat(_this.props.fileName, ".").concat(bookType), { autoBom: false });
        };
        return _this;
    }
    ExportExcel.prototype.render = function () {
        var _this = this;
        return (React.createElement("button", { onClick: function () { return _this.exportToCSV(); }, className: "button".concat(this.props.buttonDisabled ? ' button-disabled' : ''), disabled: this.props.buttonDisabled }, "Exporteren"));
    };
    return ExportExcel;
}(React.Component));
exports.default = ExportExcel;
